import { arabicLettersRegex, hebrewLettersRegex } from './Validators';

export const hidePhoneNumbers = (value, numDigitsToHide = 0, hide = false) => {
  if (!value || typeof value !== 'string') return '';
  if (!hide || numDigitsToHide === 0) return value;
  const numDigitsToShow = value.length - numDigitsToHide;
  const hiddenDigits = value.slice(-numDigitsToHide).replace(/\d/g, '*');
  const visibleDigits =
    numDigitsToShow > 0 ? value.slice(0, numDigitsToShow) : '';

  return visibleDigits + hiddenDigits;
};

export const isHebrewOrArabicLanguage = text => {
  if (!text || typeof text !== 'string') return false;
  return text
    .split('')
    .some(
      letter =>
        arabicLettersRegex.test(letter) || hebrewLettersRegex.test(letter)
    );
};

export const getLanguageDirection = (languageCode = '') => {
  const rtlLanguageIds = ['ar', 'as', 'fa', 'he', 'ku', 'ur'];
  return rtlLanguageIds.includes(languageCode);
};

export const removeDoubleSlash = text => {
  return text.replace(/\\/g, ' ');
};

export const pxToRem = px => {
  const baseFontSize = parseFloat(
    window.getComputedStyle(document.documentElement).fontSize
  );
  return px / baseFontSize;
};

export const asyncActionWithTimeout = async (asyncAction, timeout = 12000) => {
  // Create a timeout promise that rejects after the specified time
  const timeoutPromise = new Promise((resolve, _) =>
    setTimeout(() => resolve(), timeout)
  );

  try {
    return await Promise.race([asyncAction(), timeoutPromise]);
  } catch (error) {
    return null;
  }
};

export const hasPermission = (permissions, required) =>
  permissions.includes(required);

export function throttleWithTrailing(fn, wait = 5000) {
  let timeout = null;
  let lastArgs = null;
  let lastThis = null;

  const later = () => {
    if (lastArgs) {
      fn.apply(lastThis, lastArgs);
      lastArgs = null;
      lastThis = null;
      timeout = setTimeout(later, wait);
    } else {
      timeout = null;
    }
  };

  return function throttled(...args) {
    if (timeout) {
      // Store latest arguments to call later
      lastArgs = args;
      lastThis = this;
    } else {
      fn.apply(this, args);
      timeout = setTimeout(later, wait);
    }
  };
}
